const lightbox = GLightbox({
    'selector': '.glightbox',
    'href': 'https://www.youtube.com/watch?v=woxknDLGRfE&feature=youtu.be&ab_channel=CanalSoprano',
    'type': 'video',
    'source': 'youtube',
    'autoPlayVideos': 'true',
    'width': 500,
});
const lightbox2 = GLightbox({
    'selector': '.glightbox2',
    'href': 'https://www.youtube.com/watch?v=woxknDLGRfE&feature=youtu.be&ab_channel=CanalSoprano',
    'type': 'video',
    'source': 'youtube',
    'autoPlayVideos': 'true',
    'width': 500,
});